import { CodeArticle } from '@livv/models';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { PlainLink } from '@components/Links';
import OpenInNewCard from '@components/OpenInNewCard';
import { LEGIFRANCE_URL } from '@utils/consts/urls';
import { useBookPageContext } from '@utils/context/book';
import useAmplitude from '@utils/hooks/useAmplitude';
import { getLegifranceLink } from '@utils/legifrance';
import { TrackingEventName } from '@utils/types/amplitude/events';

const OfficialSource: FC = () => {
    const { t } = useTranslation('codeArticle');
    const { track } = useAmplitude();
    const { sheetData, isLegitext } = useBookPageContext();

    // If the sheet is not a code article, return null
    if (!isLegitext) {
        return null;
    }

    // If the sheet is Legitext, cast it as a CodeArticle
    const codeArticle = sheetData as CodeArticle;

    if (!codeArticle) {
        return null;
    }

    // Get the last version of the code article from the versions array
    // to avoid revoked code articles and 404 errors
    const legifranceId = codeArticle.versions.at(-1)?.legifranceId;

    if (!legifranceId) {
        return null;
    }

    const handleClick = async () => {
        await track({
            name: TrackingEventName.CODEARTICLE_OFFICIAL_SOURCE_CLICKED,
        });
    };

    return (
        <PlainLink
            href={getLegifranceLink(legifranceId)}
            onClick={handleClick}
            underline="never"
            openInNewTab
        >
            <OpenInNewCard label={t('seeOfficialSource')} overTitle={LEGIFRANCE_URL} />
        </PlainLink>
    );
};

export default OfficialSource;
